import useCachedMessageThreads from './useCachedMessageThreads';
import useSelectedMessageThreadId from './useSelectedMessageThreadId';

export default function useSelectedMessageThread(threadId?: string) {
  const { data: messageThreadsData } = useCachedMessageThreads();
  const selectedMessageThreadId = useSelectedMessageThreadId();

  const selectedThreadId = threadId || selectedMessageThreadId;

  return (messageThreadsData?.messageThreads.nodes || []).find(
    (node) => node.id === selectedThreadId,
  );
}
